import React from "react";
import { Box, Button, Layer } from "grommet";
import documentsData from "./documentsData"

const AgreementModal = ({ open, acceptCallback, cancelCallback, content }) => {
	return (
		<>
			{open && (
				<Layer>
					<Box pad="medium" overflow={{ vertical: "auto" }} height="medium">
						{documentsData[content]}
					</Box>
					<Box direction="row" align="center" justify="between" pad="medium">
						<Button label="Rechazar" onClick={cancelCallback} primary color="#f3f3f3" style={{borderRadius:7}} />
						<Button label="Aceptar" onClick={acceptCallback} style={{color:"white", borderRadius:7}} primary color="status-ok" />
					</Box>
				</Layer>
			)}
		</>
	);
};

export default AgreementModal;
